import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useNotify from 'hooks/useNotify';

const VALID_ERROR_CODES = [
  'ERROR_CONNECTING_TO_PAYPAL',
  'ERROR_CONNECTING_TO_STRIPE',
  'ERROR_CONNECTING_TO_QUICKBOOKS',
  'ERROR_CONNECTING_TO_REMOTELOCK',
] as const;

type IntegrationsErrorCode = (typeof VALID_ERROR_CODES)[number];

const useIntegrationsErrorCode = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { t } = useTranslation();
  const { notifyError } = useNotify();

  const errorCode = searchParams.get('errorCode') as IntegrationsErrorCode;

  useEffect(() => {
    if (errorCode && VALID_ERROR_CODES.includes(errorCode)) {
      notifyError(t(`pageIntegrations.apiErrorCodes.${errorCode}`));

      // Remove the error code from the search params
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.delete('errorCode');
      setSearchParams(newSearchParams);
    }
  }, [errorCode, t, searchParams, setSearchParams]);
};

export default useIntegrationsErrorCode;
